import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Card, CardContent } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import AccordionHeader from '../ui/accordion/AccordionHeader';
import AccordionIcon from '../ui/accordion/AccordionIcon';

import CourseInstanceManagement from './courseInstances/CourseInstanceManagement';
import CourseTemplateManagement from './courseTemplates/CourseTemplateManagement';
import CourseProvisionManagement from './provisions/CourseProvisionManagement';
import SelfEmployed from './selfEmployed/SelfEmployed';

import app from '../../app.module.css';

const CourseManagement = () => {
    // HOOKS
    const { state } = useLocation();

    // LOCAL STATE
    const [expanded, setExpanded] = useState(false);

    const onPanelChange = (panel) => setExpanded(expanded === panel ? '' : panel);

    // USEEFFECTS
    useEffect(() => {
        if (!state?.accordionPanel) {
            setExpanded('courses');
        } else {
            setExpanded(state.accordionPanel);
        }
    }, []);

    return (
        <Card data-testid="form_start">
            <CardContent>
                <div>
                    <h1 className={app.mainHeading}>Course Management</h1>
                    <Accordion
                        expanded={expanded === 'courses'}
                        onChange={() => onPanelChange('courses')}
                        slotProps={{ transition: { mountOnEnter: true } }}
                        className={app.accordionDivider}>
                        <AccordionSummary
                            expandIcon={<AccordionIcon />}
                            aria-controls="courses-content"
                            id="courses-header">
                            <AccordionHeader>My Courses</AccordionHeader>
                        </AccordionSummary>
                        <AccordionDetails>
                            {expanded === 'courses' && <CourseInstanceManagement />}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expanded === 'templates'}
                        onChange={() => onPanelChange('templates')}
                        slotProps={{ transition: { mountOnEnter: true } }}
                        className={app.accordionDivider}>
                        <AccordionSummary
                            expandIcon={<AccordionIcon />}
                            aria-controls="templates-content"
                            id="templates-header">
                            <AccordionHeader>My Course Templates</AccordionHeader>
                        </AccordionSummary>
                        <AccordionDetails>
                            {expanded === 'templates' && <CourseTemplateManagement />}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expanded === 'provisions'}
                        onChange={() => onPanelChange('provisions')}
                        slotProps={{ transition: { mountOnEnter: true } }}
                        className={app.accordionDivider}>
                        <AccordionSummary
                            expandIcon={<AccordionIcon />}
                            aria-controls="provisions-content"
                            id="provisions-header">
                            <AccordionHeader>Provisions</AccordionHeader>
                        </AccordionSummary>
                        <AccordionDetails>
                            {expanded === 'provisions' && <CourseProvisionManagement />}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expanded === 'selfEmployed'}
                        onChange={() => onPanelChange('selfEmployed')}
                        slotProps={{ transition: { mountOnEnter: true } }}
                        className={app.accordionDivider}>
                        <AccordionSummary
                            expandIcon={<AccordionIcon />}
                            aria-controls="selfEmployed-content"
                            id="selfEmployed-header">
                            <AccordionHeader>Self Employed Management</AccordionHeader>
                        </AccordionSummary>
                        <AccordionDetails>
                            {expanded === 'selfEmployed' && <SelfEmployed />}
                        </AccordionDetails>
                    </Accordion>
                </div>
            </CardContent>
        </Card>
    );
};

CourseManagement.propTypes = {
    accordionPanel: PropTypes.string
};

export default CourseManagement;
